import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './seibu-wire-edm/HeroSection';
import { BreadcrumbSection } from './seibu-wire-edm/BreadcrumbSection';
import { LineupOverviewSection } from './seibu-wire-edm/LineupOverviewSection';
import { BrochureSection } from './seibu-wire-edm/BrochureSection';
import { WaterSpecificationSection } from './seibu-wire-edm/WaterSpecificationSection';
import { OilSpecificationSection } from './seibu-wire-edm/OilSpecificationSection';
export function SeibuPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3691">
      <SeoBar data-id="element-3692" />
      <Header data-id="element-3693" />
      <main className="flex-grow" data-id="element-3694">
        <div className="w-full bg-gray-50 pb-20 min-h-screen font-sans" data-id="element-3695">
          <HeroSection data-id="element-3696" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3697">
            <BreadcrumbSection data-id="element-3698" />
            <LineupOverviewSection data-id="element-3699" />
            <BrochureSection data-id="element-3700" />
            <div className="space-y-16" data-id="element-3701">
              <WaterSpecificationSection data-id="element-3702" />
              <OilSpecificationSection data-id="element-3703" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-3704" />
    </div>;
}